import React, { FC } from 'react';
import PRLineItemsComponent from './PRLineItemsComponent';

const ApprovedPurchaseRequestLineItemsIndexPage: FC<any> = () => {
	return <PRLineItemsComponent isApproved />;
};

export default ApprovedPurchaseRequestLineItemsIndexPage;
